export interface LegalArticleContent {
  mainText?: string;
  bulletPoints?: string[];
  additionalText?: string[];
  contactInfo?: string;
}

export interface LegalArticle {
  titleKey: string;
  content: {
    fr: LegalArticleContent[];
    en: LegalArticleContent[];
  };
}

export const legalData: LegalArticle[] = [
  {
    titleKey: "legal.section1.title",
    content: {
      fr: [
        {
          mainText:
            "Le présent site est édité et géré par Virtuosa pour le compte de Les Chambres d'Anne :",
        },
        {
          bulletPoints: [
            "Propriétaire et éditeur du site : Virtuosa",
            "Contact éditeur : agence@virtuosa.fr",
            "Statut juridique : Entreprise enregistrée sous le numéro 819 563 057 00010",
            "Adresse : 123 Rue de la Campagne, 75000 Paris, France",
            "Téléphone : 07 86 11 50 32",
            "Responsable de publication : Anne",
          ],
        },
        {
          additionalText: [
            "Les Chambres d'Anne est une maison d'hôtes située en Seine-Maritime, offrant un hébergement de charme et divers services pour ses visiteurs.",
            "Le site chambresdanne.com est une vitrine des services et des offres d'hébergement proposés par Les Chambres d'Anne. Aucune transaction financière n'est effectuée directement sur le site.",
            "Pour toute demande technique ou signalement d'erreur sur le site, veuillez nous contacter à : agence@virtuosa.fr",
          ],
        },
      ],
      en: [
        {
          mainText:
            "This website is edited and managed by Virtuosa on behalf of Anne's Rooms:",
        },
        {
          bulletPoints: [
            "Website owner and publisher: Virtuosa",
            "Publisher contact: agence@virtuosa.fr",
            "Legal status: Company registered under number 819 563 057 00010",
            "Address: 123 Rue de la Campagne, 75000 Paris, France",
            "Phone: 07 86 11 50 32",
            "Publication manager: Anne",
          ],
        },
        {
          additionalText: [
            "Anne's Rooms is a guest house located in Seine-Maritime, offering charming accommodation and various services for its visitors.",
            "The chambresdanne.com website is a showcase of the services and accommodation offers provided by Anne's Rooms. No financial transaction is carried out directly on the site.",
            "For any technical request or error reporting on the site, please contact us at: agence@virtuosa.fr",
          ],
        },
      ],
    },
  },
  {
    titleKey: "legal.section2.title",
    content: {
      fr: [
        {
          mainText:
            "Le site dispose d'un formulaire de contact permettant de collecter les informations suivantes : nom, email, téléphone (optionnel) et message. Ces données sont collectées et traitées uniquement pour :",
        },
        {
          bulletPoints: [
            "Répondre aux demandes d'informations et de réservation.",
            "Aucune donnée n'est stockée en base de données au-delà du traitement de la demande.",
            "Les informations ne sont pas cédées à des tiers et sont supprimées une fois la demande traitée.",
            "Aucun traitement publicitaire ou commercial n'est effectué sur ces données.",
          ],
        },
        {
          additionalText: [
            "Le formulaire de contact utilise une protection anti-spam pour garantir la sécurité de vos données.",
            "Conformément au RGPD et à la loi Informatique et Libertés du 6 janvier 1978 modifiée, vous disposez des droits suivants :",
            "Droit d'accès, de rectification et de suppression de vos données.",
            "Droit d'opposition ou de limitation du traitement de vos données.",
            "Droit à la portabilité de vos données.",
          ],
        },
        {
          contactInfo: "Pour exercer vos droits : agence@virtuosa.fr",
        },
        {
          mainText:
            "Cookies : Le site peut utiliser des cookies pour améliorer votre expérience. Vous pouvez les désactiver via les paramètres de votre navigateur.",
        },
      ],
      en: [
        {
          mainText:
            "The site has a contact form that collects the following information: name, email, phone (optional) and message. This data is collected and processed only for:",
        },
        {
          bulletPoints: [
            "Responding to information and reservation requests.",
            "No data is stored in the database beyond the processing of the request.",
            "The information is not transferred to third parties and is deleted once the request has been processed.",
            "No advertising or commercial processing is carried out on this data.",
          ],
        },
        {
          additionalText: [
            "The contact form uses anti-spam protection to ensure the security of your data.",
            "In accordance with the GDPR and the French Data Protection Act of January 6, 1978 as amended, you have the following rights:",
            "Right to access, rectify and delete your data.",
            "Right to object to or limit the processing of your data.",
            "Right to data portability.",
          ],
        },
        {
          contactInfo: "To exercise your rights: agence@virtuosa.fr",
        },
        {
          mainText:
            "Cookies: The site may use cookies to improve your experience. You can disable them via your browser settings.",
        },
      ],
    },
  },
  {
    titleKey: "legal.section3.title",
    content: {
      fr: [
        {
          mainText:
            "La structure du site, les textes, les images et tout autre contenu sont la propriété exclusive de Les Chambres d'Anne, sauf mention contraire.",
        },
        {
          bulletPoints: [
            "Toute reproduction (totale ou partielle) est interdite sans autorisation écrite de Les Chambres d'Anne.",
            "Les marques et logos figurant sur ce site sont protégés et leur réutilisation non autorisée est passible de poursuites.",
          ],
        },
      ],
      en: [
        {
          mainText:
            "The structure of the site, texts, images and all other content are the exclusive property of Anne's Rooms, unless otherwise stated.",
        },
        {
          bulletPoints: [
            "Any reproduction (total or partial) is prohibited without written authorization from Anne's Rooms.",
            "The brands and logos appearing on this site are protected and their unauthorized reuse is subject to prosecution.",
          ],
        },
      ],
    },
  },
  {
    titleKey: "legal.section4.title",
    content: {
      fr: [
        {
          mainText:
            "En naviguant sur le site Les Chambres d'Anne, vous acceptez de :",
        },
        {
          bulletPoints: [
            "Respecter les lois en vigueur et les droits de propriété intellectuelle.",
            "Utiliser le site uniquement pour des finalités légitimes (consultation, informations).",
            "Ne pas perturber le bon fonctionnement du site (virus, piratage, etc.).",
          ],
        },
        {
          additionalText: [
            "Responsabilités : Les Chambres d'Anne s'efforce d'assurer l'exactitude des informations affichées. Toutefois, nous ne pouvons être tenus responsables en cas d'erreur ou de dysfonctionnement.",
          ],
        },
      ],
      en: [
        {
          mainText: "By browsing the Anne's Rooms website, you agree to:",
        },
        {
          bulletPoints: [
            "Respect current laws and intellectual property rights.",
            "Use the site only for legitimate purposes (consultation, information).",
            "Not disrupt the proper functioning of the site (viruses, hacking, etc.).",
          ],
        },
        {
          additionalText: [
            "Responsibilities: Anne's Rooms strives to ensure the accuracy of the information displayed. However, we cannot be held responsible in the event of an error or malfunction.",
          ],
        },
      ],
    },
  },
  {
    titleKey: "legal.section5.title",
    content: {
      fr: [
        {
          mainText:
            "En utilisant le site Les Chambres d'Anne, vous déclarez avoir lu et accepté l'ensemble de ces mentions légales et CGU.",
        },
      ],
      en: [
        {
          mainText:
            "By using the Anne's Rooms website, you declare that you have read and accepted all of these legal notices and terms of use.",
        },
      ],
    },
  },
];
